<template>
  <div id="contact" class="container row">
    <div class="cImage col-lg-7 col-md-6"></div>
    <div class="field col-lg-4 col-md-5">
      <div class="frame">
        info(at)gents-of-jazz.de<br/>
        +49 1511 5213865
      </div>
      <!--<form>-->
        <!--<div class="form-group">-->
          <!--<input type="text" class="form-control" id="exampleInputName1" placeholder="Name">-->
        <!--</div>-->
        <!--<div class="form-group">-->
          <!--<input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Email">-->
          <!--&lt;!&ndash;<small id="emailHelp" class="form-text text-muted">We'll never share your email with anyone else.</small>&ndash;&gt;-->
        <!--</div>-->
        <!--<div class="form-group">-->
          <!--<input type="text" class="form-control" id="exampleInputSubject1" placeholder="Betreff">-->
        <!--</div>-->
        <!--<div class="form-group">-->
          <!--<textarea class="form-control" id="exampleFormControlTextarea1" rows="5" placeholder="Nachricht"></textarea>-->
        <!--</div>-->
        <!--<button type="submit" class="btn float-md-left">Senden</button>-->
      <!--</form>-->
    </div>
  </div>
</template>

<script>
export default {
  name: 'Contact'
}
</script>

<style lang="scss" scoped>
  #contact {
    //background: #0d0d0d url("../../../assets/contact_bg.jpg") no-repeat -10em top;
    //background-size: auto 80%;
    // without contact form
    background: #000 url("../../../assets/contact_bg.jpg") no-repeat center top;
    background-size: auto 100%;
    transition: background-size 2s ease-in;
    -moz-transition: background-size 2s ease-in;
    -ms-transition: background-size 2s ease-in;
    -o-transition: background-size 2s ease-in;
    -webkit-transition: background-size 2s ease-in;
    padding: 15em 2em;

  .frame {
    width: 100%;
    text-align: center;
    line-height: 2em;
    font-size: 120%;
    padding: 1em 0;
  }

  @media all and (max-width: 540px)  {
    /*background-size: auto 60%;*/
    /*padding: 2em 2em 5em 2em;*/
    /*background-position: center;*/
    // without contact form
    background-size: auto 100%;
    padding: 2em 2em 5em 2em;
    background-position: 30% 150px;

    .frame {
      background-color: black;
    //margin-bottom: 3em;
      margin-bottom: 10em;
    }
  }
  @media all and (min-width: 1430px)  {
    background-size: auto 100%;
  }
  }
</style>



// WEBPACK FOOTER //
// src/components/partials/Contact/Contact.vue